import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-buy-prepaid-packet-thanks',
    templateUrl: './buy-prepaid-packet-thanks.component.html',
    styleUrls: ['./buy-prepaid-packet-thanks.component.css']
})
export class BuyPrepaidPacketThanksComponent implements OnInit {

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) { }

    title: string = 'GRAZIE';
    description: string;

    ngOnInit(): void {
        this.route.queryParams.subscribe(params => {
            let isTender = params['isTenderPacket'];
            if (isTender) {
                if (isTender === 'true') {
                    this.description = "Grazie per aver acquistato l'abbonamento. Potrai utilizzarlo per l'acquisto di gare.";
                } else {
                    this.description = "Grazie per aver acquistato l'abbonamento. Potrai utilizzarlo per l'acquisto di partecipazioni.";
                }
            }
        });
        const error = localStorage.getItem('BUY_PREPAID_PACKET_ERROR');
        if (error) {
            this.title = 'CI DISPIACE';
            this.description = error;
            console.log(error);
        }
    }

    goToPrepaidPacket() {
        this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'prepaidPackets' } });
        //window.open('/areariservata?tabToLoad=prepaidPackets','_self');
    }

}
